import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BlogCategory } from './blog-category';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BlogCategoryService {
    private apiUrl = `${environment.backend}/api/blogcategories`;

    constructor(private http: HttpClient) { }

    getAll(): Observable<BlogCategory[]> {
        return this.http.get<BlogCategory[]>(this.apiUrl);
    }

    /** Unauthenticated lists (e.g. footer) — same data as /active, without auth. */
    getAllPublic(): Observable<BlogCategory[]> {
        return this.http.get<BlogCategory[]>(`${this.apiUrl}/public`);
    }

    getById(id: number): Observable<BlogCategory> {
        return this.http.get<BlogCategory>(`${this.apiUrl}/${id}`);
    }

    getBySlug(slug: string): Observable<BlogCategory> {
        return this.http.get<BlogCategory>(`${this.apiUrl}/slug/${slug}`);
    }
} 